import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
} from "@mui/material";

export const feedbackStyles = {
  toast: {
    anchorOrigin: { vertical: "top", horizontal: "center" },
    autoHideDuration: 3000,
    alertSx: {
      width: "100%",
      borderRadius: 2,
      boxShadow: 3,
      alignItems: "center",
    },
  },
  dialog: {
    paperSx: {
      borderRadius: 2,
      minWidth: 360,
    },
    titleSx: {
      fontWeight: 700,
      pb: 1,
    },
    contentSx: {
      color: "text.secondary",
    },
    cancelBtnSx: {
      textTransform: "none",
      fontWeight: 600,
    },
    confirmBtnSx: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
};

export function AppToast({
  open,
  message,
  severity = "info",
  onClose,
  autoHideDuration = feedbackStyles.toast.autoHideDuration,
}) {
  const safeMessage =
    typeof message === "string"
      ? message
      : Array.isArray(message)
        ? message.map((item) => (typeof item === "string" ? item : JSON.stringify(item))).join(", ")
        : message && typeof message === "object"
          ? JSON.stringify(message)
          : String(message || "");

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={feedbackStyles.toast.anchorOrigin}
    >
      <Alert onClose={onClose} severity={severity} sx={feedbackStyles.toast.alertSx}>
        {safeMessage}
      </Alert>
    </Snackbar>
  );
}

export function AppConfirmDialog({
  open,
  title = "Confirm Action",
  content,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "error",
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === "backdropClick") return;
        onCancel?.();
      }}
      PaperProps={{ sx: feedbackStyles.dialog.paperSx }}
    >
      <DialogTitle sx={feedbackStyles.dialog.titleSx}>{title}</DialogTitle>
      <DialogContent sx={feedbackStyles.dialog.contentSx}>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel} sx={feedbackStyles.dialog.cancelBtnSx}>
          {cancelLabel}
        </Button>
        <Button color={confirmColor} onClick={onConfirm} sx={feedbackStyles.dialog.confirmBtnSx}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
